import { tv } from 'tailwind-variants';

const rangeSliderStyles = tv({
    slots: {
        container: `
      iris:flex
      iris:inline-flex
      iris:w-[298px]
      iris:flex-col
      iris:gap-(--comp-space-gap-slider)

    `,
        root: `
      iris:relative
      iris:flex
      iris:h-(--comp-size-box-slider-target)
      iris:touch-none
      iris:items-center
      iris:select-none
    `,
        track: `
      iris:relative
      iris:h-(--comp-size-height-slider-track)
      iris:w-full
      iris:rounded-(--comp-size-radius-slider-track)
      iris:bg-(--comp-color-background-slider-track)
    `,
        range: `
      iris:absolute
      iris:h-full
      iris:rounded-(--comp-size-radius-slider-track)
      iris:bg-(--comp-color-content-slider-active-track)
    `,
        trackLabels: `
      iris:flex
      iris:w-full
      iris:justify-between
      iris:font-(family-name:--comp-type-font-input-helper)
      iris:text-(length:--comp-type-size-input-helper)
      iris:leading-(--base-type-leading-normal)
      iris:tracking-(--comp-type-tracking-input-helper)
      iris:text-(--comp-color-content-input-helper-default)
    `,
        minLabel: `
      iris:w-1/2
      iris:text-left
      iris:whitespace-nowrap
    `,
        maxLabel: `
      iris:w-1/2
      iris:text-right
      iris:whitespace-nowrap
    `,
    },
    variants: {
        disabled: {
            true: {
                container: "iris:pointer-events-none iris:opacity-50",
            },
        },
        inverse: {
            true: {
                range: "iris:bg-(--comp-color-content-slider-active-track-inverse)",
                track: "iris:bg-(--comp-color-background-slider-track-inverse)",
                trackLabels: "iris:text-(--comp-color-content-input-helper-inverse-default)",
            },
        },
    },
    defaultVariants: {
        disabled: false,
        inverse: false,
    },
});

export { rangeSliderStyles as default, rangeSliderStyles };
